// extracted by mini-css-extract-plugin
export var emailBlockLink = "_nb-0";